import shortingArray from "@/mixins/MultishortArray";
export default {
    mixins: [shortingArray],
    prop:{
        listWO: []
    },
    data() {
        return {
            isCollective: false,
            selected: [],
            collectiveLoading: false,
            mlistWO: [],
            mListEdited: [],
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    methods: {
        onCollective() {
            this.collectiveLoading = true;
            this.mlistWO= [];
            this.mListEdited= []
            if (this.listWO.length>0){
                let a = []
                a = [...this.mListEdited,JSON.parse(JSON.stringify(this.listWO))];
                this.mListEdited = a
                this.mlistWO = a[0].filter(
                    (obj) => obj.values.is_item == 'yes'
                );
                this.collectiveLoading = false;
                this.isCollective = true;
            }else{
                this.displayMessageValue("basic-error", 'Data detil PO is Empty!')
                this.collectiveLoading = false;
            }
        },
        handleCloseCollective() {
            let as = this.mListEdited[0];
            this.reset();
            this.isCollective = false;
            Event.$emit("updateList", as);
        },
        handleCheck(e) {
            const item = e.target.value;
                this.selected.filter(obj => obj.key == item.key).length == 0 ? this.selected.push(item) : this.selected.splice(this.selected.findIndex(obj => obj.key == item.key), 1)
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        handlePp(e) {
            this.selectedPp = this.ppdetillist.filter(
                (obj) => obj.id_pp_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.displayMessage("form-warning");
                    return;
                }

                //check saldo if return minus after recounting
                let ikey = this.ppdetillist.findIndex((obj => obj.id_pp_dtl == values.kode_anggaran));

                let renom = parseFloat(this.ppdetillist[ikey].nilai_dtl_pp)
                let trigProces = true

                for (let index = 0; index < this.selected.length; index++) {
                    renom = renom - parseFloat(this.selected[index].values.hargaTotal)
                    trigProces = renom<0 ? false : true
                }

                if (!trigProces){
                    this.displayMessage("grather-remaining");
                    return;
                }

                for (let index = 0; index < this.selected.length; index++) {
                    let objIndex = this.mListEdited[0].findIndex((obj => obj.key == this.selected[index].key));
                    this.mListEdited[0][objIndex].selectedPPdtl = String(this.ppdetillist[ikey].id_pp_dtl);
                    this.mListEdited[0][objIndex].pp_kode_anggaran = String(this.ppdetillist[ikey].kode_anggaran);
                    this.mListEdited[0][objIndex].pp_nama_barang = String(this.ppdetillist[ikey].nama_barang);
                    this.mListEdited[0][objIndex].values.selectedPPdtl = String(this.ppdetillist[ikey].id_pp_dtl);
                    this.mListEdited[0][objIndex].values.pp_kode_anggaran = String(this.ppdetillist[ikey].kode_anggaran);
                    this.mListEdited[0][objIndex].values.pp_nama_barang = String(this.ppdetillist[ikey].nama_barang);
                }

                for (let index = 0; index < this.ppdetillist.length; index++) {
                    this.ppdetillist[index].nilai_dtl_pp =
                        this.ppdetillist[index].nilai_dtl_pp_origin;
                }
                for (let index = 0; index < this.mListEdited[0].length; index++) {
                    if(this.mListEdited[0][index].selectedPPdtl && this.mListEdited[0][index].selectedPPdtl!=='undefined'){
                        let lkey = this.ppdetillist.findIndex((obj => obj.id_pp_dtl == this.mListEdited[0][index].selectedPPdtl));
                        this.ppdetillist[lkey].nilai_dtl_pp = 
                        parseFloat(this.ppdetillist[lkey].nilai_dtl_pp) - parseFloat(this.mListEdited[0][index].values.hargaTotal);
                    }
                }
                this.selected = []
                this.mListEdited[0] = this.ArrshortMultiCol(this.mListEdited[0], {
                    pp_kode_anggaran: "asc",
                  });
                for (let index = 0; index < this.mListEdited[0].length; index++) { 
                this.mListEdited[0][index].no = index+1;
                }
                this.mlistWO = this.mListEdited[0].filter(
                    (obj) => obj.values.is_item == 'yes'
                );
                this.isCollective = true
                this.displayMessage("success-save");
                this.reset();
            })
        },
        reset() {
            this.formCollective.resetFields();
            this.selected = [];
        },
    }
}